import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { FilterConfig, FilterContext, FilterData } from './types';

export const getFiltersState = (state: RootState) => state?.filters;

export const getFiltersByContext = (
  state: RootState,
  context: FilterContext,
): FilterData => getFiltersState(state)?.filters?.[context] || {};

export const getFilterConfigByContext = (
  state: RootState,
  context: FilterContext,
): FilterConfig | undefined => getFiltersState(state)?.configs?.[context];

export const getAllFilters = (state: RootState) =>
  getFiltersState(state)?.filters || {};

export const getAllConfigs = (state: RootState) =>
  getFiltersState(state)?.configs || {};

export const hasFilters = createSelector(
  [getFiltersState, (state: RootState, context: FilterContext) => context],
  (filtersState, context) => {
    const filters = filtersState?.filters?.[context] || {};
    return Object.keys(filters).length > 0;
  },
);

export const getFilterCount = createSelector(
  [getFiltersState, (state: RootState, context: FilterContext) => context],
  (filtersState, context) => {
    const filters = filtersState?.filters?.[context] || {};
    return Object.keys(filters).filter(
      (key) => filters[key] != null && filters[key] !== '',
    ).length;
  },
);
